export default __webpack_public_path__ + "static/media/atdata.8482d6eb.jpg";